import React, { useEffect, useState } from "react";
import {
  AccordianNew,
  Button,
  FormFieldSet,
  LoopFieldsSet,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../components";
import {
  MonsterEducationLevel,
  optionsMonsterPostFrom,
  optionsMonsterTo,
  countryMonsterOptions,
  MonsterPowerSearchTravelRequirementsOptions,
  MonsterPowerSearchTenureOptions,
  ClearanceLeveloptions,
  optionValuescitizen,
  careerMonsterLevelOptions,
  MonsterSearchResumeUpdatedOptions,
  MonsterRadiusOptions,
} from "../../../assets/data/enumData";
import { v4 as uuidv4 } from "uuid";
import { getMonsterApplicantsDataStart } from "../../../redux/slices/internalDbES/internalDbESlice";
import { useDispatch } from "react-redux";
import {
  getCountries,
  getLocations,
} from "../../../redux/slices/internalDbES/internalDbESApi";
const MonsterFiltersModal = ({ query, updateQuery, setPage }) => {
  const existingData = query?.payload?.query || {};
  const dispatch = useDispatch();
  const [semanticRadioSelect, setSemanticRadioSelect] = useState(false);
  const [toggleWithLabel, setToggleWithLabel] = useState(false);
  const [showMonsterAdvancedOptions, setShowMonsterAdvancedOptions] =
    useState(false);
  const safeDecode = (v) => {
    try {
      return typeof v === "string" ? decodeURIComponent(v) : v;
    } catch {
      return v;
    }
  };

  const decodedLocations = existingData?.loc
    ? safeDecode(existingData.loc)
      .split("+")
      .map((item) => {
        const [zip, miles] = item.split("-");
        return {
          id: uuidv4(),
          zip: zip ?? "",
          miles: miles ?? "",
        };
      })
    : [{ id: uuidv4(), zip: "", miles: "" }];

  const typingMap = {};
  decodedLocations.forEach((l, idx) => {
    if (l.zip) typingMap[idx] = l.zip;
  });

  const locationTypingData =
    query?.searchType === "power"
      ? typingMap
      : safeDecode(existingData?.loc ?? "").replace(/-\d+$/, "");

  const [selectedCountryId, setSelectedCountryId] = useState({});
  const [selectedCountryCode, setSelectedCountryCode] = useState(
    existingData.country === 840 ? "United States" : "Canada" || "United States"
  );
  const [locationTypingValue, setLocationTypingValue] =
    useState(locationTypingData);
  const [locations, setLocations] = useState([]);

  // console.log("locationTypingValue",locationTypingValue);

  const handleSelection = (event) => {
    setSemanticRadioSelect(event.target.value);
  };
  const decodeMonsterSearchSkills = (skills) => {
    if (!Array.isArray(skills) || skills.length === 0) return [];

    return skills
      .map((skill) => {
        if (typeof skill !== "string") return null;

        const encodedValue = skill.split(" ")[0];

        try {
          return decodeURIComponent(decodeURIComponent(encodedValue));
        } catch {
          return encodedValue;
        }
      })
      .filter(Boolean);
  };

  const decodePowerSkills = (skills) => {
    if (!Array.isArray(skills) || skills.length === 0) return [];

    return skills
      .map((skill) => {
        if (typeof skill !== "string") return null;

        const [encodedValue, req = "nth"] = skill.split(" ");

        try {
          return {
            value: decodeURIComponent(decodeURIComponent(encodedValue)),
            req,
          };
        } catch {
          return { value: encodedValue, req };
        }
      })
      .filter(Boolean);
  };

  const formatPowerSkills = (skills) => {
    if (!Array.isArray(skills) || skills.length === 0) return "";

    const doubleEncode = (str) =>
      encodeURIComponent(encodeURIComponent(str.trim()));

    const processed = skills
      .filter((s) => s.skillKeywords?.trim())
      .map((s) => `${doubleEncode(s.skillKeywords)} ${s.req || "nth"}`);

    return processed.length ? processed : "";
  };
  const formatMonsterSkills = (skills) => {
    if (!Array.isArray(skills) || skills.length === 0) return "";

    const doubleEncode = (str) =>
      encodeURIComponent(encodeURIComponent(str.trim()));

    const processed = skills
      .map((skill) => {
        // Case 1: skill is a string
        if (typeof skill === "string" && skill.trim()) {
          return `${doubleEncode(skill)} nth`;
        }

        // Case 2: skill is an object { value, req }
        if (skill?.value && skill.value.trim()) {
          return `${doubleEncode(skill.value)} ${skill?.req || "nth"}`;
        }

        return null;
      })
      .filter(Boolean);

    return processed.length > 0 ? processed : "";
  };
  const decodedSkills = decodePowerSkills(existingData?.sk);
  const decodeResumeUpdated = (mdatemaxage) => {
    if (!mdatemaxage) return 0;

    // Special "Any time" value
    if (Number(mdatemaxage) === 1576800) return 0;

    // Convert minutes → days
    return Math.round(Number(mdatemaxage) / 1440);
  };

  const initialFormData = {
    jobTitleOrKeyword: existingData.q || "",
    from: existingData.mdateminage || 0,
    to: existingData.mdatemaxage || 43200,
    mostRecentEmployer: existingData.qrcn || "",
    mostRecentJobTitle: existingData.qrjt || "",
    mostRecentDescription: existingData.qrjd || "",
    schoolAttended: existingData.qsn || "",
    searchType: existingData.searchType || "Semantic",
    distance: existingData.radius || 50,
    rlid: existingData.rlid || "",
    // jobDetails: existingData.jt
    //   ? existingData.jt.split(",").map((job) => ({
    //     id: uuidv4(),
    //     jobTitle: job.trim(),
    //   }))
    //   : [{ id: uuidv4(), jobTitle: "" }],
    jobDetails: existingData.jt
      ? safeDecode(existingData.jt)
        .split(",")
        .map((job) => ({
          id: uuidv4(),
          jobTitle: job.trim(),
        }))
      : [{ id: uuidv4(), jobTitle: "" }],

    // keywords: existingData.bkeyword || "",
    // booleanKeywords: existingData.bkeyword || "",
    resumeUpdated: decodeResumeUpdated(existingData.mdatemaxage) || 0,
    highEducation: existingData.minedulvid || "",
    degreeMajor: existingData.edumjr || "",
    keywords: safeDecode(existingData.bkeyword) || "",
    booleanKeywords: safeDecode(existingData.bkeyword) || "",
    // skills: existingData.sk
    //   ? existingData.sk
    //     .split(",")
    //     .map((s) => ({ id: uuidv4(), skillKeywords: s.trim() }))
    //   : [{ id: uuidv4(), skillKeywords: "" }],

    // skills: Array.isArray(existingData?.sk) && existingData.sk.length
    //   ? existingData.sk.map((s) => ({
    //     id: uuidv4(),
    //     skillKeywords: s?.trim() || "",
    //   }))
    //   : [{ id: uuidv4(), skillKeywords: "" }],

    //       skills: [
    //   {
    //     id: uuidv4(),
    //     skillKeywords: "",
    //     req: "nth", // default
    //   },
    // ],

    skills:
      decodedSkills.length > 0
        ? decodedSkills.map((s) => ({
          id: uuidv4(),
          skillKeywords: s.value,
          req: s.req || "nth",
        }))
        : [{ id: uuidv4(), skillKeywords: "", req: "nth" }],

    // location: existingData.location
    //   ? existingData.location.split(",").map((loc) => {
    //     const [zipPart, milesPart] = loc.split("-").map((s) => s.trim());
    //     const zip = zipPart?.replace("miles", "").trim() || "";
    //     const miles = milesPart
    //       ? milesPart.replace("miles", "").trim() + " miles"
    //       : "";
    //     return { id: uuidv4(), zip, miles };
    //   })
    //   : [{ id: uuidv4(), zip: "", miles: "" }],

    location: existingData?.loc
      ? safeDecode(existingData.loc)
        .split("+") // split multiple locations
        .map((item) => {
          const [zip, miles] = item.split("-");
          return {
            id: uuidv4(),
            zip: zip ?? "",
            miles: miles ?? "",
          };
        })
      : [{ id: uuidv4(), zip: "", miles: "" }],

    // location: existingData?.loc
    //   ? [{ id: uuidv4(), zip: safeDecode(existingData?.loc)?.replace(/-\d+$/, "") ?? "", miles: "" }]
    //   : [{ id: uuidv4(), zip:  "", miles: "" }],
    country:
      existingData.country === 840
        ? "United States"
        : "Canada" || "United States",
    experience: existingData.yex || "",
    candidateName: existingData.cname || "",
    salaryType: existingData.salaryType || "year",
    salaryLevel: existingData.salaryLevel || "",
    includeDetails: "1",
    desiredJobDuration: existingData.ten || "",
    willingToTravel: existingData.wtt || "",

    jobType: existingData.tjtid
      ? existingData.tjtid
        .split(",")
        .map((v) => Number(v.trim()))
        .filter((n) => !isNaN(n))
      : [],

    relocation: existingData.relo ? ["relocate"] : [],

    citizenship: existingData.lstat
      ? existingData.lstat.split(",").map((v) => v.trim())
      : [],

    securityClearance: existingData.gsc
      ? existingData.gsc
        .split(",")
        .map((v) => Number(v.trim()))
        .filter((n) => !isNaN(n))
      : [],

    company: existingData.comp
      ? existingData.comp.split(",").map((c) => ({ companyName: c.trim() }))
      : [{ companyName: "" }],

    degree: existingData.edumjr
      ? existingData.edumjr.split(",").map((d) => ({ degreeName: d.trim() }))
      : [{ degreeName: "" }],

    school: existingData.sch
      ? existingData.sch.split(",").map((s) => ({ schoolName: s.trim() }))
      : [{ schoolName: "" }],

    // jobTitle: existingData.jt
    //   ? existingData.jt
    //     .split(",")
    //     .map((j) => j.trim())
    //     .filter(Boolean)
    //     .join(", ")
    //   : "",

    jobTitle: existingData.jt
      ? safeDecode(existingData.jt)
        .split(",")
        .map((j) => j.trim())
        .filter(Boolean)
        .join(", ")
      : "",

    // skill: existingData.sk
    //   ? existingData.sk
    //     .split(",")
    //     .map((j) => j.trim())
    //     .filter(Boolean)
    //     .join(", ")
    //   : "",
    // skill: Array.isArray(existingData?.sk) && existingData.sk.length > 0
    //   ? (existingData.sk[0]?.trim() || "")
    //   : "",
    skill: Array.isArray(existingData?.sk)
      ? decodeMonsterSearchSkills(existingData.sk.flat(Infinity)).join(", ")
      : "",

    workAuthorization: existingData.wa || "",
    yearsOfExperience: existingData.yex || "",
    travel: existingData.wtt || "",
    jobDuration: existingData.ten || "",
    education: existingData.minedulvid || "",
    careerLevel: existingData.clvid
      ? existingData.clvid
        .split(",")
        .map((v) => Number(v.trim()))
        .filter(Boolean)
      : [],

    candidateFilters: [
      ...(existingData.relo ? ["Willing to Relocate"] : []),
      ...(existingData.veteran === 1 ? ["Veterans Only"] : []),
    ],

    resumeUploaded:
      existingData.mdatemaxage === 1576800
        ? 0
        : existingData.mdatemaxage
          ? existingData.mdatemaxage / 1440
          : 0,
  };

  const buildBooleanSearch = (include = "") => {
    const clean = (text) =>
      text
        .split(/[\s,]+/) // split by any space or comma
        .map((t) => t.trim())
        .filter(Boolean);
    // .filter((t) => !["and", "or", "not"].includes(t.toLowerCase())); // remove logical words if typed manually

    const includeKeywords = clean(include);
    const includePart = includeKeywords.join(" ");

    return includePart || "";
  };

  const handleClassicSearch = () => {
    if (!formData.jobTitleOrKeyword) {
      showToast("Job Title or keyword is required!", "error");
      return;
    }

    // Map form fields to Monster request payload fields
    const filters = {
      q: buildBooleanSearch(formData.jobTitleOrKeyword) || "",
      mdateminage: formData.from || 0,
      mdatemaxage: formData.to || 43200,
      rlid: formData.rlid || "",
      qrcn: formData.mostRecentEmployer || "",
      qrjt: formData.mostRecentJobTitle || "",
      qrjd: formData.mostRecentDescription || "",
      qsn: formData.schoolAttended || "",
    };

    // Merge new filters with existing query
    const updatedQuery = {
      ...query,
      payload: {
        ...query?.payload,
        page: 1,
        query: {
          ...query?.payload?.query,
          ...filters,
        },
      },
    };

    // Dispatch Monster search with updated filters
    dispatch(
      getMonsterApplicantsDataStart({
        ...updatedQuery,
        onSuccess: () => {
          updateQuery(updatedQuery);
          if (setPage) setPage(1);
          // console.log("Monster filters updated successfully");
        },
      })
    );
  };

  const handlePowerSearch = () => {
    const locationValue = formData.location
      .map((l) => {
        if (!l.zip) return null;
        const miles = l.miles || formData.distance || 50;
        return `${l.zip}-${miles}`;
      })
      .filter(Boolean)
      .join("+");

    const skillsArray = formData.skills || [];

    // const skillsArray =
    //   formData.skills
    //     ?.map((s) => s.skillKeywords?.trim())
    //     .filter(Boolean) || [];
    // Map form fields to Monster request payload fields

    // console.log("selectedCountryCode",selectedCountryCode);

    const filters = {
      // jt: formData.jobDetails?.length
      //   ? formData.jobDetails
      //     .map((item) => item.jobTitle?.trim())
      //     .filter(Boolean)
      //     .join(", ")
      //   : "",
      jt: formData.jobDetails?.length
        ? encodeURIComponent(
          formData.jobDetails
            .map((item) => item.jobTitle?.trim())
            .filter(Boolean)
            .join(", ")
        )
        : "",
      // sk: skillsArray.length > 0 ? skillsArray : "",
      sk: formatPowerSkills(skillsArray),
      // location:
      //   formData.location
      //     ?.map((l) => {
      //       const zip = l.zip?.trim();
      //       const miles = l.miles;
      //       if (zip && miles) return `${zip} - ${miles} miles`;
      //       if (zip) return zip;
      //       if (miles) return `${miles} miles`;
      //       return "";
      //     })
      //     .filter(Boolean)
      //     .join(", ") || "",
      country: Number(selectedCountryCode) || "US",
      // loc: locationParts.length
      //       ? `${locationParts.join(",")}-${distance}`
      //       : "",
      loc: encodeURIComponent(locationValue) || "US",
      radius: formData.distance || 50,
      tjtid: formData.jobType?.filter(Boolean).join(", ") || "",
      ten: formData.desiredJobDuration || "",
      wtt: formData.willingToTravel || "",
      relo: (formData.relocation?.includes("relocate") && true) || "",
      lstat: formData.citizenship?.filter(Boolean).join(", ") || "",
      gsc: formData.securityClearance?.filter(Boolean).join(", ") || "",
      // bkeyword: formData.keywords?.trim() || "",
      bkeyword: encodeURIComponent(formData.keywords?.trim() || ""),
      yex: formData.experience || "",
      // country: "US",
      salaryType: formData.salaryType || "",
      salaryLevel: formData.salaryLevel || "",
      tsni: Number(formData.includeDetails) || "",
      mdatemaxage:
        formData.resumeUpdated === 0 ? 1576800 : 1440 * formData.resumeUpdated,
      minedulvid: formData.highEducation || "",
      edumjr: formData.degreeMajor || "",
    };

    // Merge new filters with existing query
    const updatedQuery = {
      ...query,
      payload: {
        ...query?.payload,
        page: 1,
        query: {
          ...query?.payload?.query,
          ...filters,
        },
      },
    };

    // Dispatch Monster search with updated filters
    dispatch(
      getMonsterApplicantsDataStart({
        ...updatedQuery,
        onSuccess: () => {
          updateQuery(updatedQuery);
          if (setPage) setPage(1);
          // console.log("Monster filters updated successfully");
        },
      })
    );
  };

  const handleMonsterSearch = () => {
    // Map form fields to Monster request payload fields
    const [state, city, zipCode] = locationTypingValue.split(",");

    const distance = formData.distance || 50;

    const locationParts = [state, city, zipCode].filter(Boolean);

    const locationValue = locationParts.length
      ? `${locationParts.join(",")}-${distance}`
      : "";

    const filters = {
      searchType: formData.searchType,
      // jt: formData.jobTitle,
      jt: encodeURIComponent(formData.jobTitle || ""),
      // bkeyword: formData.booleanKeywords,
      bkeyword: encodeURIComponent(formData.booleanKeywords || ""),
      sk: formData?.skill ? formatMonsterSkills([formData?.skill]) : "",
      country: Number(selectedCountryCode) || "US",
      // loc: locationParts.length
      //       ? `${locationParts.join(",")}-${distance}`
      //       : "",

      loc: encodeURIComponent(locationValue) || "US",

      comp: formData.company
        .map((c) => c.companyName?.trim())
        .filter(Boolean)
        .join(","),

      edumjr: formData.degree
        .map((d) => d.degreeName?.trim())
        .filter(Boolean)
        .join(","),

      sch: formData.school
        .map((s) => s.schoolName?.trim())
        .filter(Boolean)
        .join(","),

      tjtid: formData.jobType?.filter(Boolean).join(",") || "",
      lstat: formData.citizenship?.filter(Boolean).join(",") || "",
      gsc: formData.securityClearance?.filter(Boolean).join(",") || "",

      wa: formData.workAuthorization ? "164-1" : "",
      radius: formData.distance || 50,

      yex: formData.yearsOfExperience,
      wtt: formData.travel,
      ten: formData.jobDuration,
      minedulvid: formData.education,
      clvid: formData.careerLevel?.filter(Boolean).join(",") || "",

      relo: formData.candidateFilters?.includes("Willing to Relocate")
        ? true
        : "",
      veteran: formData.candidateFilters?.includes("Veterans Only") ? 1 : "",

      // mdatemaxage:
      //   formData.resumeUploaded === 0
      //     ? 1576800
      //     : 1440 * formData.resumeUploaded,
      mdatemaxage:
        formData.resumeUploaded === 0
          ? 1576800
          : 1440 * formData.resumeUploaded,

      tsni: Number(formData.includeDetails) || "",

      cname: formData.candidateName,
    };

    // Merge new filters with existing query
    const updatedQuery = {
      ...query,
      payload: {
        ...query?.payload,
        page: 1,
        query: {
          ...query?.payload?.query,
          ...filters,
        },
      },
    };

    // Dispatch Monster search with updated filters
    dispatch(
      getMonsterApplicantsDataStart({
        ...updatedQuery,
        onSuccess: () => {
          updateQuery(updatedQuery);
          if (setPage) setPage(1);
          // console.log("Monster filters updated successfully");
        },
      })
    );
  };

  const { formData, errors, handleChange, setFormData } = useFormHandler(
    initialFormData,
    {}
  );

  // console.log("formData.country",formData.country);

  /** ---- Dynamic Add/Remove Handlers ---- **/
  const addJobTitle = () =>
    setFormData({
      ...formData,
      jobDetails: [...formData.jobDetails, { id: uuidv4(), jobTitle: "" }],
    });

  const removeJobTitle = (id) =>
    formData.jobDetails.length > 1 &&
    setFormData({
      ...formData,
      jobDetails: formData.jobDetails.filter((d) => d.id !== id),
    });

  const addSkill = () =>
    setFormData({
      ...formData,
      skills: [
        ...formData.skills,
        { id: uuidv4(), skillKeywords: "", req: "nth" },
      ],
    });

  const removeSkill = (id) =>
    formData.skills.length > 1 &&
    setFormData({
      ...formData,
      skills: formData.skills.filter((d) => d.id !== id),
    });

  const addLocation = () =>
    setFormData({
      ...formData,
      location: [...formData.location, { id: uuidv4(), zip: "", miles: "" }],
    });

  const removeLocation = (id, index) => {
    if (formData.location.length > 1) {
      setFormData({
        ...formData,
        location: formData.location.filter((d) => d.id !== id),
      });

      setLocationTypingValue((prev) => {
        const copy = { ...prev };
        delete copy[index];
        return copy;
      });
    }
  };

  const addCompany = () => {
    const newCompany = {
      id: uuidv4(),
      companyName: "",
    };

    setFormData({
      ...formData,
      company: [...formData.company, newCompany],
    });
  };
  const removeCompany = (companyId) => {
    if (formData.company.length > 1) {
      const updatedCompanies = formData.company.filter(
        (com) => com.id !== companyId
      );
      setFormData({
        ...formData,
        company: updatedCompanies,
      });
    }
  };
  const addDegree = () => {
    const newDegree = {
      id: uuidv4(),
      degreeName: "",
    };

    setFormData({
      ...formData,
      degree: [...formData.degree, newDegree],
    });
  };
  const removeDegree = (degreeId) => {
    if (formData.degree.length > 1) {
      const updatedDegrees = formData.degree.filter(
        (deg) => deg.id !== degreeId
      );
      setFormData({
        ...formData,
        degree: updatedDegrees,
      });
    }
  };
  const addSchool = () => {
    const newSchool = {
      id: uuidv4(),
      schoolName: "",
    };

    setFormData({
      ...formData,
      school: [...formData.school, newSchool],
    });
  };
  const removeSchool = (schoolId) => {
    if (formData.school.length > 1) {
      const updatedSchools = formData.school.filter(
        (sch) => sch.id !== schoolId
      );
      setFormData({
        ...formData,
        school: updatedSchools,
      });
    }
  };

  //  useEffect(() => {
  //        const [city, state, zip] = locationTypingValue.split(",");
  //        if (city && state) return;

  //        const delay = setTimeout(async () => {
  //          setLocations([])
  //          const response = await getLocations({ locationValue: locationTypingValue, country: selectedCountryId?._id, limit: 500, });
  //          if (response?.success) {
  //           //  const uniqueStates = [...new Set((response?.data?.data || []).map(item => item.stateName))];
  //            const locationData = response?.data?.data.flatMap((item) => {
  //              const name = item.name ?? "";
  //              const state = item.stateName ?? "";
  //              if (Array.isArray(item.zipCode)) {
  //                return item.zipCode.map((zc) => `${name},${state},${zc}`);
  //              }
  //              return [`${name},${state},${item.zipCode ?? ""}`];
  //            });
  //           //  setLocations([...uniqueStates,...locationData ])
  //            const search = locationTypingValue.toLowerCase();
  //       // const statesStartsWith = uniqueStates.filter((item) =>
  //       //   item.toLowerCase().startsWith(search)
  //       // );
  //       // const statesContains = uniqueStates.filter(
  //       //   (item) =>
  //       //     item.toLowerCase().includes(search) &&
  //       //     !item.toLowerCase().startsWith(search)
  //       // );
  //       const locationsStartsWith = locationData.filter((item) =>
  //         item.toLowerCase().startsWith(search)
  //       );
  //       const locationsContains = locationData.filter(
  //         (item) =>
  //           item.toLowerCase().includes(search) &&
  //           !item.toLowerCase().startsWith(search)
  //       );
  //       // statesStartsWith.sort((a, b) => a.localeCompare(b));
  //       // statesContains.sort((a, b) => a.localeCompare(b));
  //       locationsStartsWith.sort((a, b) => a.localeCompare(b));
  //       locationsContains.sort((a, b) => a.localeCompare(b));
  //       setLocations([
  //         // ...statesStartsWith,
  //         ...locationsStartsWith,
  //         // ...statesContains,
  //         ...locationsContains,
  //       ]);
  //          }
  //        }, 0);

  //        return () => clearTimeout(delay);
  //      }, [locationTypingValue, formData?.country]);

  useEffect(() => {
    if (!locationTypingValue) return;

    const fetchLocations = async (value) => {
      if (!value) return;

      const parts = value.split(",");
      const city = parts[0];
      const state = parts[1];
      const zip = parts[2];

      // Stop if already fully resolved
      if (city && state && zip) return;

      const response = await getLocations({
        locationValue: value,
        country: selectedCountryId?._id,
        limit: 500,
      });

      if (!response?.success) return;

      const locationData = response.data.data.flatMap((item) => {
        const name = item.name ?? "";
        const state = item.stateName ?? "";

        if (Array.isArray(item.zipCode)) {
          return item.zipCode.map((zc) => `${name},${state},${zc}`);
        }

        return [`${name},${state},${item.zipCode ?? ""}`];
      });

      const search = value.toLowerCase();

      const startsWith = locationData
        .filter((i) => i.toLowerCase().startsWith(search))
        .sort((a, b) => a.localeCompare(b));

      const contains = locationData
        .filter(
          (i) =>
            i.toLowerCase().includes(search) &&
            !i.toLowerCase().startsWith(search)
        )
        .sort((a, b) => a.localeCompare(b));

      setLocations([...startsWith, ...contains]);
    };

    const delay = setTimeout(() => {
      //  POWER → object
      if (
        query?.searchType === "power" &&
        typeof locationTypingValue === "object"
      ) {
        Object.values(locationTypingValue).forEach(fetchLocations);
      }

      //  MONSTER → string
      if (
        query?.searchType !== "power" &&
        typeof locationTypingValue === "string"
      ) {
        fetchLocations(locationTypingValue);
      }
    }, 300);

    return () => clearTimeout(delay);
  }, [locationTypingValue, formData?.country, query?.searchType]);

  useEffect(() => {
    if (!formData?.country) return;

    const delay = setTimeout(async () => {
      const response = await getCountries({ name: formData?.country });
      const countries = response?.data?.data;
      const desiredCountryId = countries[0];
      setSelectedCountryId(desiredCountryId);
      setSelectedCountryCode(desiredCountryId?.numericCode);
      //  setLocationTypingValue("");
    }, 0);

    return () => clearTimeout(delay);
  }, [formData?.country]);

  // useEffect(() => {
  //     Object.entries(locationTypingValue).forEach(([index, value]) => {
  //       if (!value) return;

  //       const [city, state, zip] = value.split(",");
  //       if (city && state && zip) return;
  //       console.log("selectedCountryId",selectedCountryId);

  //       const delay = setTimeout(async () => {
  //         const response = await getLocations({
  //           locationValue: value,
  //           country: selectedCountryId?._id,
  //           limit: 500,
  //         });

  //         if (response?.success) {
  //           const locationData = response?.data?.data.flatMap((item) => {
  //             const name = item.name ?? "";
  //             const state = item.stateName ?? "";

  //             if (Array.isArray(item.zipCode)) {
  //               return item.zipCode.map(
  //                 (zc) => `${name},${state},${zc}`
  //               );
  //             }
  //             return [`${name},${state},${item.zipCode ?? ""}`];
  //           });

  //           const search = value.toLowerCase();

  //           const startsWith = locationData
  //             .filter((i) => i.toLowerCase().startsWith(search))
  //             .sort((a, b) => a.localeCompare(b));

  //           const contains = locationData
  //             .filter(
  //               (i) =>
  //                 i.toLowerCase().includes(search) &&
  //                 !i.toLowerCase().startsWith(search)
  //             )
  //             .sort((a, b) => a.localeCompare(b));

  //           setLocations([...startsWith, ...contains]);
  //         }
  //       }, 300);

  //       return () => clearTimeout(delay);
  //     });
  //   }, [locationTypingValue, formData?.country]);

  const data = [
    {
      title: "Resume Search Criteria",
      content: (
        <div>
          {/* Years of Experience */}
          <FormFieldSet
            title="Years of Experience"
            placeholder="Suggested,4,2-3,5+,<8"
            value={formData.yearsOfExperience || ""}
            onChange={(value) => handleChange("yearsOfExperience", value)}
            shadow
          />
          <p className="text-xs text-neutrals-400 my-1">
            (e.g, MBA, MS Math, MSCS, English)
          </p>

          {/* Career Level */}
          <div className="my-3">
            <FormFieldSet
              type="checkbox"
              title="Career Level"
              options={careerMonsterLevelOptions}
              values={formData.careerLevel || []}
              onChange={(value) => handleChange("careerLevel", value)}
              multiple
            />
          </div>

          {/* Job Duration */}
          {/* Job Duration */}
          <div className="my-3">
            <FormFieldSet
              type="radio"
              name="jobDuration"
              title="Job Duration"
              options={MonsterPowerSearchTenureOptions}
              value={formData.jobDuration || ""}
              onChange={(e) => handleChange("jobDuration", e.target.value)}
            />
          </div>

          {/* Companies */}
          <LoopFieldsSet
            title="Companies"
            titleConfig={{
              tag: "h6",
            }}
            data={formData.company}
            onAdd={addCompany}
            onRemove={removeCompany}
            maxItems={3}
            gridCols="grid-cols-10"
            addButtonTitle="Add Companies"
            renderFields={(company, index) => (
              <div className="col-span-9">
                <FormFieldSet
                  type="text"
                  placeholder="(e.g. IHOP Corp, IBM Global Services)"
                  value={company.companyName || ""}
                  onChange={(value) => {
                    const updated = [...formData.company];
                    updated[index].companyName = value;
                    setFormData({ ...formData, company: updated });
                  }}
                  shadow
                />
              </div>
            )}
          />

          {/* Degrees */}
          <LoopFieldsSet
            title="Degrees"
            titleConfig={{
              tag: "h6",
            }}
            data={formData.degree}
            onAdd={addDegree}
            onRemove={removeDegree}
            maxItems={3}
            gridCols="grid-cols-10"
            addButtonTitle="Add Degrees"
            renderFields={(deg, index) => (
              <div className="col-span-9">
                <FormFieldSet
                  type="text"
                  placeholder="(e.g. Computer Engineering)"
                  value={deg.degreeName || ""}
                  onChange={(value) => {
                    const updated = [...formData.degree];
                    updated[index].degreeName = value;
                    setFormData({ ...formData, degree: updated });
                  }}
                  shadow
                />
                <FormFieldSet
                  type="checkbox"
                  options={[{ label: "Required", value: "Required" }]}
                  values={deg.required || []}
                  onChange={(value) => {
                    const updated = [...formData.degree];
                    updated[index].required = value;
                    setFormData({ ...formData, degree: updated });
                  }}
                  noTitle
                  multiple
                />
              </div>
            )}
          />

          {/* Schools */}
          <LoopFieldsSet
            title="Schools"
            titleConfig={{
              tag: "h6",
            }}
            data={formData.school}
            onAdd={addSchool}
            onRemove={removeSchool}
            maxItems={3}
            gridCols="grid-cols-10"
            addButtonTitle="Add Schools"
            renderFields={(sch, index) => (
              <div className="col-span-9">
                <FormFieldSet
                  type="text"
                  placeholder="(e.g. UCLA, Siena College, Lowa State Univ)"
                  value={sch.schoolName || ""}
                  onChange={(value) => {
                    const updated = [...formData.school];
                    updated[index].schoolName = value;
                    setFormData({ ...formData, school: updated });
                  }}
                  shadow
                />
              </div>
            )}
          />
        </div>
      ),
    },
    {
      title: "Profile Search Criteria",
      content: (
        <div>
          <p className="text-sm my-3">
            Please be advised that these search options come from candidate
            profiles, so results may vary depending on what information is
            provided.
          </p>

          {/* Resume Uploaded + Candidate Name */}
          <div className="grid grid-cols-2 gap-3 my-3">
            <FormFieldSet
              type="select"
              title="Resume Uploaded"
              placeholder="All Resumes"
              options={MonsterSearchResumeUpdatedOptions}
              value={formData.resumeUploaded}
              onChange={(value) => handleChange("resumeUploaded", value)}
            />
            <FormFieldSet
              title="Candidate Name"
              placeholder="(e.g. mark, john wayne)"
              value={formData.candidateName || ""}
              onChange={(value) => handleChange("candidateName", value)}
            />
          </div>

          {/* Job Type */}
          <FormFieldSet
            type="checkbox"
            size="md"
            title="Job Type"
            options={[
              { label: "Full-Time", value: 1 },
              { label: "Part-time", value: 2 },
              { label: "Intern", value: 3 },
              { label: "Temporary/Contract", value: 4 },
              { label: "Seasonal", value: 5 },
            ]}
            values={formData.jobType || []}
            onChange={(value) => handleChange("jobType", value)}
            multiple
          />

          {/* Citizenship */}
          <FormFieldSet
            type="checkbox"
            title="Citizenship"
            options={optionValuescitizen}
            values={formData.citizenship || []}
            onChange={(value) => handleChange("citizenship", value)}
            multiple
          />

          {/* Security Clearance */}
          <FormFieldSet
            type="checkbox"
            title="Security Clearance"
            options={ClearanceLeveloptions}
            values={formData.securityClearance || []}
            onChange={(value) => handleChange("securityClearance", value)}
            multiple
          />

          {/* Maximum Salary */}
          <FormFieldSet
            type="radio"
            title="Maximum Salary"
            name="maxSalary"
            list
            options={[
              { label: "Per Year", value: "year" },
              { label: "Per Hour", value: "hour" },
            ]}
            value={formData.salaryType || ""}
            onChange={(e) => handleChange("salaryType", e.target.value)}
          />
          <FormFieldSet
            type="select"
            noTitle
            placeholder="Salary Level"
            options={[
              { label: "$30,000", value: "30000" },
              { label: "$40,000", value: "40000" },
              { label: "$50,000", value: "50000" },
              { label: "$60,000", value: "60000" },
              { label: "$70,000", value: "70000" },
              { label: "$80,000", value: "80000" },
              { label: "$90,000", value: "90000" },
            ]}
            value={formData.salaryLevel || ""}
            onChange={(value) => handleChange("salaryLevel", value)}
          />
          <FormFieldSet
            type="checkbox"
            size="md"
            noTitle
            placeholder="Select"
            options={[
              {
                label: "Include candidates without salary information",
                value: "1",
              },
            ]}
            values={formData?.includeDetails}
            onChange={(value) => handleChange("includeDetails", value)}
            error={errors?.includeDetails}
          />

          {/* Travel */}
          <FormFieldSet
            type="radio"
            title="Willing To Travel"
            name="willingToTravel"
            options={MonsterPowerSearchTravelRequirementsOptions}
            value={formData.travel || ""}
            onChange={(e) => handleChange("travel", e.target.value)}
          />

          {/* Education */}
          <FormFieldSet
            type="radio"
            title="Education"
            name="education"
            options={MonsterEducationLevel}
            value={formData.education || ""}
            onChange={(e) => handleChange("education", e.target.value)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="w-full overflow-auto pr-2 pl-2">
      {query?.searchType === "classic" && (
        <div>
          <PageTitle title={"Filter Result"} tag="h5" />
          <div className="grid grid-cols-1 gap-5 mt-5">
            <FormFieldSet
              noTitle
              placeholder="Keyword"
              value={formData.jobTitleOrKeyword || ""}
              onChange={(value) => handleChange("jobTitleOrKeyword", value)}
              error={errors.jobTitleOrKeyword}
              shadow={true}
            />

            <PageTitle title={"Resume Updated"} tag="p" />
            <FormFieldSet
              noTitle
              placeholder="From"
              options={optionsMonsterPostFrom}
              type="select"
              value={formData.from}
              onChange={(value) => handleChange("from", value)}
              error={errors.from}
              shadow={true}
            />
            <FormFieldSet
              noTitle
              placeholder="To"
              options={optionsMonsterTo}
              type="select"
              value={formData.to}
              onChange={(value) => handleChange("to", value)}
              error={errors.to}
              shadow={true}
            />
            <FormFieldSet
              placeholder="Most Recent Employer"
              title="Most Recent Employer"
              value={formData.mostRecentEmployer}
              onChange={(value) => handleChange("mostRecentEmployer", value)}
              error={errors.mostRecentEmployer}
              shadow={true}
            />
            <FormFieldSet
              placeholder="Most Recent Job Title"
              title="Most Recent Job Title"
              value={formData.mostRecentJobTitle}
              onChange={(value) => handleChange("mostRecentJobTitle", value)}
              error={errors.mostRecentJobTitle}
              shadow={true}
            />
            <FormFieldSet
              placeholder="Most Recent Description"
              title="Most Recent Description"
              value={formData.mostRecentDescription}
              onChange={(value) => handleChange("mostRecentDescription", value)}
              error={errors.mostRecentDescription}
              shadow={true}
            />
            <FormFieldSet
              placeholder="School Attended"
              title="School Attended"
              value={formData.schoolAttended}
              onChange={(value) => handleChange("schoolAttended", value)}
              error={errors.schoolAttended}
              shadow={true}
            />
          </div>
          <div className="flex justify-end mt-2">
            <Button
              variant="text"
              title={
                showMonsterAdvancedOptions
                  ? "- Hide Advanced Options"
                  : "+ show Advanced options"
              }
              color="info"
              className="italic underline underline-offset-2 decoration-2"
            //   onClick={() => setShowMonsterAdvancedOptions((prev) => !prev)}
            />
          </div>

          {/* Fixed bottom Apply button */}
          <div className="sticky bottom-0 bg-white pt-4 pb-2 flex gap-3 justify-end mt-1">
            <Button
              variant="outlined"
              title="Reset"
              onClick={() => setFormData(initialFormData)}
            />
            <Button title="Search" onClick={handleClassicSearch} />
          </div>
        </div>
      )}
      {query?.searchType === "power" && (
        <div>
          <PageTitle title={"Filter Result"} tag="h5" />
          <div className="grid grid-cols-1 gap-5 mt-5">
            <FormFieldSet
              noTitle
              type="radio"
              options={[
                { label: "Semantic", value: "Semantic" },
                {
                  label: "Boolean Search",
                  value: "Boolean Search",
                },
              ]}
              value={formData.searchType}
              onChange={(e) => handleChange("searchType", e.target.value)}
              error={errors.searchType}
            />
            <div className="grid grid-cols-1">
              {formData.searchType === "Semantic" && (
                <>
                  <LoopFieldsSet
                    title="Job Titles"
                    titleConfig={{
                      tag: "h6",
                    }}
                    data={formData.jobDetails}
                    onAdd={addJobTitle}
                    onRemove={removeJobTitle}
                    maxItems={3}
                    gridCols="grid-cols-10"
                    addButtonTitle="Add More Job Titles"
                    renderFields={(detail, index) => (
                      <div className="col-span-9">
                        <FormFieldSet
                          type="text"
                          title="Job Title"
                          placeholder="Job Title"
                          value={detail.jobTitle || ""}
                          onChange={(value) =>
                            handleChange(`jobDetails[${index}].jobTitle`, value)
                          }
                          error={errors.jobDetails?.[index]?.jobTitle}
                          shadow
                        />
                        <p className="mt-1 text-xs">
                          (e.g., Sales, Accountant)
                        </p>
                      </div>
                    )}
                  />
                  <LoopFieldsSet
                    title="Skill Keywords"
                    titleConfig={{
                      tag: "h6",
                    }}
                    data={formData.skills}
                    onAdd={addSkill}
                    onRemove={removeSkill}
                    maxItems={3}
                    gridCols="grid-cols-10"
                    addButtonTitle="Add More Skills"
                    renderFields={(skill, index) => (
                      <>
                        {/* Skill input */}
                        <div className="col-span-8">
                          <FormFieldSet
                            type="text"
                            title="Enter terms related to candidates industry, or expertise (e.g java, telesales, call center, SOX)"
                            placeholder="Skills"
                            value={skill?.skillKeywords}
                            onChange={(value) =>
                              handleChange(
                                `skills[${index}].skillKeywords`,
                                value
                              )
                            }
                            error={errors.skills?.[index]?.skillKeywords}
                            shadow
                          />
                        </div>

                        {/* req / nth toggle */}
                        <div className="col-span-2 flex items-center pt-4">
                          <div className="inline-flex items-center gap-1">
                            <FormFieldSet
                              type="toggle"
                              title=""
                              size="sm"
                              isChecked={skill?.req === "req"}
                              onChange={(checked) =>
                                handleChange(
                                  `skills[${index}].req`,
                                  checked ? "req" : "nth"
                                )
                              }
                            />

                            {/* Label next to toggle */}
                            <span className="text-sm text-gray-600 pt-4">
                              {skill?.req === "req" ? "req" : "nth"}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  />
                </>
              )}
              {formData.searchType === "Boolean Search" && (
                <>
                  <FormFieldSet
                    title="Keywords"
                    placeholder="Keywords"
                    value={formData.keywords}
                    onChange={(value) => handleChange("keywords", value)}
                    shadow={true}
                  />
                  <FormFieldSet
                    title="Years of Experience"
                    placeholder="Years of Experience"
                    value={formData.experience}
                    onChange={(value) => handleChange("experience", value)}
                    shadow={true}
                  />
                </>
              )}

              <div className="my-3">
                <h6 className="my-2">Locations</h6>
                <FormFieldSet
                  title="Enter city, state, country or zip code"
                  // type="select"
                  type="countriesUsAndCanada"
                  // options={countryMonsterOptions}
                  value={formData.country}
                  onChange={(value) => handleChange("country", value.value)}
                  shadow={true}
                />

                <LoopFieldsSet
                  title=" "
                  titleConfig={{
                    tag: "h6",
                  }}
                  data={formData?.location}
                  onAdd={addLocation}
                  onRemove={removeLocation}
                  maxItems={3}
                  gridCols="grid-cols-11"
                  addButtonTitle="Add location details"
                  renderFields={(loc, index) => (
                    <>
                      {/* ZIP */}
                      <div className="col-span-5 mx-2">
                        <FormFieldSet
                          noTitle
                          placeholder="Zip Code"
                          value={locationTypingValue[index] ?? loc.zip ?? ""}
                          onChange={(value) => {
                            setLocationTypingValue((prev) => ({
                              ...prev,
                              [index]: value,
                            }));
                            handleChange(`location[${index}].zip`, value);
                            setLocations([]);
                          }}
                          shadow
                          suggestionsList={locations}
                        />
                      </div>

                      {/* MILES */}
                      <div className="col-span-5 mx-2">
                        <FormFieldSet
                          type="select"
                          noTitle
                          placeholder="Miles away"
                          options={MonsterRadiusOptions}
                          value={loc.miles}
                          onChange={(value) =>
                            handleChange(`location[${index}].miles`, value)
                          }
                          shadow
                        />
                      </div>
                    </>
                  )}
                />
              </div>

              <FormFieldSet
                title="Resume Updated"
                placeholder="Resume Updated"
                options={MonsterSearchResumeUpdatedOptions}
                type="select"
                value={formData?.resumeUpdated}
                onChange={(value) => handleChange("resumeUpdated", value)}
                // error={errors?.from}
                shadow={true}
              />

              <FormFieldSet
                title="Education"
                placeholder="Minimun Education Level"
                options={MonsterEducationLevel}
                type="select"
                value={formData?.highEducation}
                onChange={(value) => handleChange("highEducation", value)}
                // error={errors?.from}
                shadow={true}
              />

              <FormFieldSet
                // noTitle
                title=" "
                type="text"
                placeholder="Degree/Major"
                value={formData?.degreeMajor}
                // value={locationTypingValue}
                onChange={(value) => handleChange("degreeMajor", value)}
              // onChange={(value) => setLocationTypingValue(value)}
              // error={errors?.zipCode}
              // shadow={true}
              // suggestionsList={locations}
              />
              <p className="mt-1 text-xs">
                (e.g., MBA, MS Math, MSCS, English)
              </p>

              {/* <h6 className="my-2">Locations</h6>
              <FormFieldSet
                title="Enter city, state, country or zip code"
                type="select"
                options={countryMonsterOptions}
                value={formData.country}
                onChange={(value) => handleChange("country", value)}
                shadow={true}
              /> */}

              {/* <LoopFieldsSet
                title=" "
                data={formData.location}
                onAdd={addLocation}
                onRemove={removeLocation}
                maxItems={3}
                gridCols="grid-cols-11"
                addButtonTitle="Add location details"
                renderFields={(loc, index) => (
                  <>
                    <div className="col-span-5 mx-2">
                      <FormFieldSet
                        type="text"
                        noTitle
                        placeholder="Zip"
                        value={loc.zip}
                        onChange={(value) =>
                          handleChange(`location[${index}].zip`, value)
                        }
                        shadow={true}
                      />
                    </div>
                    <div className="col-span-5 mx-2">
                      <FormFieldSet
                        type="select"
                        noTitle
                        placeholder="Miles away"
                        options={[
                          { label: "5 miles away", value: "5 miles away" },
                          { label: "10 miles away", value: "10 miles away" },
                          { label: "20 miles away", value: "20 miles away" },
                          { label: "30 miles away", value: "30 miles away" },
                          { label: "40 miles away", value: "40 miles away" },
                          { label: "50 miles away", value: "50 miles away" },
                          { label: "60 miles away", value: "60 miles away" },
                          { label: "70 miles away", value: "70 miles away" },
                        ]}
                        value={loc.miles}
                        onChange={(value) =>
                          handleChange(`location[${index}].miles`, value)
                        }
                        shadow={true}
                      />
                    </div>
                  </>
                )}
              /> */}
            </div>

            <FormFieldSet
              type="radio"
              title="Maximum Salary"
              name="salaryType"
              options={[
                { label: "Per Year", value: "year" },
                { label: "Per Hour", value: "hour" },
              ]}
              value={formData.salaryType}
              onChange={(e) => handleChange("salaryType", e.target.value)}
            />
            <FormFieldSet
              type="select"
              noTitle
              placeholder="Salary Level"
              options={[
                { label: "$ 30000", value: "$ 30000" },
                { label: "$ 40000", value: "$ 40000" },
                { label: "$ 50000", value: "$ 50000" },
                { label: "$ 60000", value: "$ 60000" },
                { label: "$ 70000", value: "$ 70000" },
                { label: "$ 80000", value: "$ 80000" },
                { label: "$ 90000", value: "$ 90000" },
              ]}
              value={formData.salaryLevel}
              onChange={(value) => handleChange("salaryLevel", value)}
            />

            <FormFieldSet
              type="checkbox"
              size="md"
              noTitle
              placeholder="Select"
              options={[
                {
                  label: "Include candidates without salary information",
                  value: "1",
                },
              ]}
              values={formData?.includeDetails}
              onChange={(value) => handleChange("includeDetails", value)}
              error={errors?.includeDetails}
            />
            {/* <FormFieldSet
              type="checkbox"
              size="md"
              noTitle
              placeholder="Enter Zip Code"
              options={[
                {
                  label: "Include candidates without salary information",
                  value: "1",
                },
              ]}
            /> */}
            <FormFieldSet
              type="checkbox"
              size="md"
              title="Job Type"
              options={[
                { label: "Full-Time", value: 1 },
                { label: "Part-time", value: 2 },
                { label: "Intern", value: 3 },
                { label: "Temporary/Contract", value: 4 },
                { label: "Seasonal", value: 5 },
              ]}
              values={formData.jobType}
              onChange={(newValues) => handleChange("jobType", newValues)}
              multiple
            />
            <FormFieldSet
              type="select"
              title="Desired Job Duration"
              placeholder="Select Desired Job Duration"
              options={MonsterPowerSearchTenureOptions}
              value={formData.desiredJobDuration}
              onChange={(value) => handleChange("desiredJobDuration", value)}
              shadow={true}
            />
            <FormFieldSet
              type="select"
              title="Willing To Travel"
              placeholder="Select"
              options={MonsterPowerSearchTravelRequirementsOptions}
              value={formData.willingToTravel}
              onChange={(value) => handleChange("willingToTravel", value)} // ✅ update formData
              shadow={true}
            />
            <FormFieldSet
              type="checkbox"
              size="md"
              title="Relocation"
              options={[
                {
                  label:
                    "Limit result to job seekers who are willing to relocate",
                  value: "relocate",
                },
              ]}
              values={formData.relocation || []}
              onChange={(newValues) => handleChange("relocation", newValues)}
              multiple
            />
            <FormFieldSet
              type="checkbox"
              size="md"
              title="Citizenship"
              options={optionValuescitizen}
              values={formData.citizenship || []}
              onChange={(newValues) => handleChange("citizenship", newValues)}
              multiple
            />
            <FormFieldSet
              type="checkbox"
              size="md"
              title="Security Clearance"
              options={ClearanceLeveloptions}
              values={formData.securityClearance || []}
              onChange={(newValues) =>
                handleChange("securityClearance", newValues)
              }
              multiple
            />
          </div>
          <div className="flex justify-end mt-2">
            <Button
              variant="text"
              title={
                showMonsterAdvancedOptions
                  ? "- Hide Advanced Options"
                  : "+ show Advanced options"
              }
              color="info"
              className="italic underline underline-offset-2 decoration-2"
            //   onClick={() => setShowMonsterAdvancedOptions((prev) => !prev)}
            />
          </div>

          <div className="sticky bottom-0 bg-white pt-4 pb-2 flex gap-3 justify-end mt-1">
            <Button
              variant="outlined"
              title="Reset"
              onClick={() => setFormData(initialFormData)}
            />
            <Button title="Search" onClick={handlePowerSearch} />
          </div>
        </div>
      )}
      {query?.searchType === "monster" && (
        <div>
          <PageTitle title={"Filter Result"} tag="h5" />
          <div className="grid grid-cols-1 gap-1 mt-5">
            <FormFieldSet
              noTitle
              type="radio"
              options={[
                { label: "Semantic", value: "Semantic" },
                {
                  label: "Boolean Search",
                  value: "Boolean Search",
                },
              ]}
              value={formData.searchType}
              onChange={(e) => handleChange("searchType", e.target.value)}
              error={errors.searchType}
            />
            <div className="grid grid-cols-1">
              {formData.searchType === "Semantic" && (
                <>
                  <div>
                    <p className="text-sm font-[500] my-2">Job Title</p>
                    <FormFieldSet
                      type="text"
                      title="Entering a Job Title is highly recommended"
                      placeholder="Job Title"
                      value={formData.jobTitle || ""}
                      onChange={(value) => handleChange("jobTitle", value)}
                      shadow={true}
                    />
                    <p className="mt-1 text-xs">(eg, Sales, Accountant,)</p>
                  </div>
                  <div>
                    <p className="text-sm font-[500] my-2">Skill Keywords</p>
                    <FormFieldSet
                      type="text"
                      title="Enter terms related to candidates industry, or expertise (e.g java,telesales,call center,SOX)"
                      placeholder="Skills"
                      value={formData.skill}
                      onChange={(value) => handleChange("skill", value)}
                      shadow={true}
                    />
                  </div>
                </>
              )}
              {formData.searchType === "Boolean Search" && (
                <FormFieldSet
                  title="Boolean Search"
                  placeholder="Javascript, Management, Finance"
                  value={formData.booleanKeywords}
                  onChange={(value) => handleChange("booleanKeywords", value)}
                  shadow
                />
              )}

              <p className="text-sm font-[500] my-2">Location</p>
              <div className="grid grid-cols-2  gap-4">
                <FormFieldSet
                  noTitle
                  placeholder="Location"
                  value={locationTypingValue}
                  onChange={(value) => {
                    setLocationTypingValue(value);
                    handleChange("location", value);
                    setLocations([]);
                  }}
                  shadow={true}
                  suggestionsList={locations}
                />
                <FormFieldSet
                  type="select"
                  noTitle
                  options={MonsterRadiusOptions}
                  placeholder="30 miles away"
                  value={formData?.distance}
                  onChange={(value) => handleChange("distance", value)}
                  error={errors?.distance}
                  shadow={true}
                />
              </div>
            </div>
            {showMonsterAdvancedOptions && (
              <div className="grid grid-cols-1 gap-3">
                <PageTitle title="Select Candidate Filters" tag="h6" />
                <FormFieldSet
                  type="checkbox"
                  noTitle
                  multiple
                  options={[
                    {
                      label: "Limit results to candidates willing to relocate",
                      value: "Willing to Relocate",
                    },
                    {
                      label: "Limit results to designated as veterans",
                      value: "Veterans Only",
                    },
                  ]}
                  values={formData.candidateFilters || []}
                  onChange={(value) => handleChange("candidateFilters", value)}
                />
                <PageTitle title="Work Authorization" tag="h6" />
                <FormFieldSet
                  noTitle
                  type="radio"
                  name="workAuth"
                  list
                  options={[
                    { label: "Show all job seekers", value: "" },
                    {
                      label:
                        "Limit to job seekers authorized to work in this country for any employer",
                      value: "164-1",
                    },
                    {
                      label:
                        "Limit to job seekers authorized to work in this country for their current employer only",
                      value: "164-2",
                    },
                    {
                      label:
                        "Limit to job seekers that require sponsorship to work in this country",
                      value: "164-3",
                    },
                  ]}
                  value={formData.workAuthorization || ""}
                  onChange={(e) =>
                    handleChange("workAuthorization", e.target.value)
                  }
                />
                <AccordianNew data={data} color="white" variant="outlined" />
              </div>
            )}
          </div>
          <div className="flex justify-end mt-2">
            <Button
              variant="text"
              title={
                showMonsterAdvancedOptions
                  ? "- Hide Advanced Options"
                  : "+ show Advanced options"
              }
              color="info"
              className="italic underline underline-offset-2 decoration-2"
              onClick={() => setShowMonsterAdvancedOptions((prev) => !prev)}
            />
          </div>

          {/* Fixed bottom Apply button */}
          <div className="sticky bottom-0 bg-white pt-4 pb-2 flex gap-3 justify-end mt-1">
            <Button
              variant="outlined"
              title="Reset"
              onClick={() => setFormData(initialFormData)}
            />
            <Button title="Search" onClick={handleMonsterSearch} />
          </div>
        </div>
      )}
    </div>
  );
};

export default MonsterFiltersModal;
